(function () {
  var data = window.buundleRecentSales || [];
  var names = window.buundleRecentSalesNames || [];
  if (!data.length) return;

  var container = document.getElementById('buundle-recent-sales');
  if (!container) return;

  // Shuffle once so it doesn't feel scripted in the same order every visit
  for (var i = data.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = data[i]; data[i] = data[j]; data[j] = tmp;
  }

  var index = 0;
  var SHOW_MS = 5000;
  var GAP_MS = 7000;
  var FIRST_DELAY_MS = 4000;
  var lastName = null;

  function minutesAgoText() {
    var mins = 2 + Math.floor(Math.random() * 40);
    return mins + ' minute' + (mins === 1 ? '' : 's') + ' ago';
  }

  function pickName() {
    if (!names.length) return null;
    var name = names[Math.floor(Math.random() * names.length)];
    // avoid repeating the same name back-to-back
    if (name === lastName && names.length > 1) {
      return pickName();
    }
    lastName = name;
    return name;
  }

  function render(entry) {
    var name = pickName();
    var whoLine = name
      ? '<strong>' + name + '</strong> in ' + entry.city + ' just ordered'
      : 'Someone in <strong>' + entry.city + '</strong> just ordered';

    container.innerHTML =
      '<span class="buundle-recent-sales__icon">\uD83D\uDED2</span>' +
      '<span class="buundle-recent-sales__text">' +
        whoLine + '<br>' +
        '<span class="buundle-recent-sales__product">' + entry.product + '</span>' +
        '<span class="buundle-recent-sales__meta">' + minutesAgoText() + '</span>' +
      '</span>' +
      '<button type="button" class="buundle-recent-sales__close" aria-label="Dismiss">\u2715</button>';

    var closeBtn = container.querySelector('.buundle-recent-sales__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        container.classList.remove('is-visible');
        clearTimeout(hideTimer);
      });
    }
  }

  var hideTimer;

  function showNext() {
    var entry = data[index % data.length];
    index++;

    render(entry);
    container.classList.add('is-visible');

    hideTimer = setTimeout(function () {
      container.classList.remove('is-visible');
      setTimeout(showNext, GAP_MS);
    }, SHOW_MS);
  }

  setTimeout(showNext, FIRST_DELAY_MS);
})();
